/** Extract a YouTube video id from common URL shapes. */
export function parseYouTubeId(input) {
  if (!input || typeof input !== "string") return null;
  const raw = input.trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(raw)) return raw;

  try {
    const url = new URL(raw);
    const host = url.hostname.replace(/^www\./, "");

    if (host === "youtu.be") {
      const id = url.pathname.split("/").filter(Boolean)[0];
      return id && /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : null;
    }

    if (host === "youtube.com" || host === "m.youtube.com" || host === "music.youtube.com") {
      const v = url.searchParams.get("v");
      if (v && /^[a-zA-Z0-9_-]{11}$/.test(v)) return v;

      const parts = url.pathname.split("/").filter(Boolean);
      // /embed/ID, /shorts/ID, /live/ID, /v/ID
      if (parts.length >= 2 && ["embed", "shorts", "live", "v"].includes(parts[0])) {
        const id = parts[1];
        return id && /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : null;
      }
    }
  } catch {
    return null;
  }
  return null;
}

export function youtubeEmbedUrl(idOrUrl) {
  const id = parseYouTubeId(idOrUrl);
  return id ? `https://www.youtube.com/embed/${id}` : "";
}

export function youtubeThumbnailUrl(idOrUrl) {
  const id = parseYouTubeId(idOrUrl);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}
